/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React from 'react';
import UserDetails from '../components/UserDetails';
import Button from '../components/Button';
import styled from 'styled-components';
import ContributeProcess from '../components/ContributionProcess';
import { CustomBtn, CenteredContainer } from '../components/Typography';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../components/Routes';
import ContriProcessMobile from '../components/ContributionProcess/ContriProcessMobile';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';

const StyleContPro = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`;

const NoticeText = styled.p`
  font-family: 'Noto Sans';
  font-style: italic;
  font-weight: 600;
  font-size: 18px;
  line-height: 175%;
  text-align: center;
  color: #51a69e;
  white-space: pre-wrap;
  width: 50%;
  @media (max-width: 767px) {
    width: 90%;
    padding: 0 20px;
    font-size: 16px;
  }
`;
const ImportantTextContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 25px 0px 25px;
  background: rgba(252, 170, 232, 0.2);
  background: #fff;
  width: 80%;
  margin: 40px auto 0px;
  border-bottom: 2px solid #464646;
  border-radius: 0px 0px 20px 20px;
  @media (max-width: 767px) {
    width: 95%;
  }
`;
const VariableText = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight || 400};
  font-size: ${(props) => props.Size || '16px'};
  line-height: ${(props) => props.lineHeight || '150%'};
  text-align: center;
  color: ${(props) => props.color || '#000000'};
  white-space: pre-wrap;
  // width: 50%;
  margin-top: ${(props) => props.marginTop || '0px'};
`;
const Home = () => {
  const navigate = useNavigate();
  const TITLE = 'Make Contribution - BSG Contribution Site';
  const handleClick = () => {
    const isContributionEnabled =
      process.env.REACT_APP_CONTRIBUTION_ENABLED === 'true';

    if (isContributionEnabled) {
      navigate(ROUTES.CONTRIBUTION_FIRST_PAGE);
    } else {
      toast.error('Contribution is not Enabled', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
    }
  };
  return (
    <div>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <UserDetails />
      <CustomBtn marginTop="50px" onClick={handleClick}>
        <Button>Click here to Contribute</Button>
      </CustomBtn>
      <ImportantTextContainer>
        <VariableText color="#282828" lineHeight="175%" fontWeight="500">
          <span style={{ color: '#009cbf' }}>Important-</span> Please check your
          Name and Address displayed above, to ensure that they are correct. As
          the Contribution Receipt will be generated on the same. In case they
          are not correct. Please DO NOT proceed, and contact your District
          Stats Coordinator or District Leader for getting the corrections made.
          Please make the contributions only after the corrections have been
          done.
        </VariableText>
      </ImportantTextContainer>
      <StyleContPro>
        <ContributeProcess />
      </StyleContPro>
      <ContriProcessMobile />
      <CenteredContainer
        marginBottom="30px"
        style={{
          width: '80%',
          borderRadius: '20px',
          marginLeft: 'auto',
          marginRight: 'auto',
          background: '#ffdede',
        }}
      >
        <NoticeText
          style={{
            fontWeight: '600',
            fontSize: '16px',
            lineHeight: '175%',
            textAlign: 'center',
            color: '#c30000',
            whiteSpace: 'pre-wrap',
            width: '90%',
            '@media(max-width:767px)': {
              fontSize: '16px',
              width: '90%',
            },
          }}
        >
          “FOREIGN NATIONAL MEMBERS ARE NOT ALLOWED TO USE THIS SITE FOR MAKING
          CONTRIBUTION. IF ANY FOREIGN NATIONAL MEMBERS MAKES CONTRIBUTION
          THROUGH THIS SITE, BSG WOULD NOT ACCEPT THEIR CONTRIBUTION.”
        </NoticeText>
      </CenteredContainer>
    </div>
  );
};

export default Home;
